import { render, staticRenderFns } from "./MainMatch_man.vue?vue&type=template&id=53c60140&scoped=true"
import script from "./MainMatch_man.vue?vue&type=script&lang=js"
export * from "./MainMatch_man.vue?vue&type=script&lang=js"
import style0 from "./MainMatch_man.vue?vue&type=style&index=0&id=53c60140&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c60140",
  null
  
)

export default component.exports